(ns app.front.view.admin.gis.core
  (:require [app.front.ui :as ui]
            [app.front.ui.section :as section]
            [app.front.ui.table :as ui-table]
            [app.front.util :refer [for-frag]]
            [app.front.view.admin.gis.i18n-mapping-config :as gis-i18n-mapping-config]
            [app.front.view.admin.gis.server-config :as gis-server-config]
            [app.front.view.admin.gis.subs :as gis-subs]
            [core.front.event :refer [<sub >evt]]))


(defn config-features [tr {:keys [config]}]
  (for-frag [c config]
    (let [layers? (= c :map-layers)]
      [ui/tag {:type       :round
               :color      (if layers? :night-sky :blue)
               :class-name "first:ml-0 cloudpermit--tag--round"}
       (tr [(if layers? :map/layers (keyword "gis-search-config.role" c))])])))


(defn config-implementation [{:keys [gis-implementation]}]
  [:span.p-1 {:class (when (not= gis-implementation :gis-implementation/generic) "bg-yellow-600")} gis-implementation])


(defn domain-group-custom-config-list [tr]
  (when-let [configs (<sub [::gis-subs/domain-group-custom-configs])]
    [:div.mt-2
     [:div.w-full.mt-5
      [ui-table/modern-responsive-table
       {:items   configs
        :tr      tr
        :cols    [[:group/name
                   :group-name
                   {:width "20%"}]
                  [:group/id
                   :group-id
                   {:width "10%"}]
                  [:gis-server-config/custom-config-implementation
                   config-implementation
                   {:width "20%"}]
                  [:gis-server-config/custom-config-features
                   (partial config-features tr)
                   {}]]
        :id-func :group-id}]]]))


(defn groupless-custom-config-list [tr]
  (when-let [configs (<sub [::gis-subs/groupless-custom-configs])]
    [:div.mt-2
     [:div.flex.justify-between.items-center
      [:h4.m-0 (tr [:gis-server-config/custom-config-without-group])]]
     [:div.w-full.mt-5
      [ui-table/modern-responsive-table
       {:items   configs
        :tr      tr
        :cols    [[:group/id
                   :group-id
                   {:width "10%"}]
                  [:gis-server-config/custom-config-implementation
                   config-implementation
                   {:width "20%"}]
                  [:gis-server-config/custom-config-features
                   (partial config-features tr)
                   {}]]
        :id-func :group-id}]]]))


(defn custom-configs [tr]
  [section/section
   :custom-configs
   {:tr                   tr
    :initially-collapsed? true}
   (tr [:gis-server-config/custom-config-title])
   [:div.flex.flex-col
    [:span (tr [:gis-server-config/custom-config-implementation-note])]]
   [domain-group-custom-config-list tr]
   [groupless-custom-config-list tr]])


(defn view [_]
  (let [tr (<sub [:tr])]
    [:div.cloudpermit-page.admin-page
     [:div.bx--row.page-heading.justify-between
      [:h1 (tr [:view/admin.gis-configs])]]
     [gis-server-config/gis-server-list tr]
     [gis-i18n-mapping-config/mapping-list tr]
     [custom-configs tr]]))


(def route
  {:name        :view/admin.gis-configs
   :view        view
   :controllers [{:start (fn [_]
                           (>evt [::gis-subs/init]))}]})
